import {Tag} from 'antd';
import {useState} from 'react';
import api from '../../api';
import CRUD from '../../components/CRUD';
import MeetingArchiveToggle from '../../components/MeetingArchiveToggle';
import {
    formatDate,
    normalizeDateFields,
    normalizeOutDateFields
} from '../../utils/normalize';
import MeetingAccompanyProgramList from './MeetingAccompanyProgramList';
import MeetingControlForm from './MeetingControlForm';
import MeetingEmailTemplate2Form from './MeetingEmailTemplate2Form';
import MeetingEmailTemplateForm from './MeetingEmailTemplateForm';
import MeetingEveningProgramList from './MeetingEveningProgramList';
import MeetingParkingPassList from './MeetingParkingPassList';
import MeetingPlaceList from './MeetingPlaceList';
import MeetingSpecialProgramList from './MeetingSpecialProgramList';

const MeetingControlList = () => {
    const [showArchived, setShowArchived] = useState(false);
    const columns = [
        {
            title: 'Datum von',
            dataIndex: 'date_from',
            key: 'date_from',
            render: (text => {
               return formatDate(text)
            }),
            sorter: (a, b) => a.date_from > b.date_from,
        },
        {
            title: 'Datum bis',
            dataIndex: 'date_to',
            key: 'date_to',
            render: (text => {
               return formatDate(text)
            }),
            sorter: (a, b) => a.date_to > b.date_to,
        },
        {
            title: 'Tagung',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => a.name > b.name,
        },
        {
            title: 'Räumlichkeiten',
            dataIndex: 'place',
            key: 'place',
            sorter: (a, b) => a.place > b.place,
        },
        {
            title: 'Ort',
            dataIndex: 'area',
            key: 'area',
            sorter: (a, b) => a.area > b.area,
        },
        {
            title: 'Status',
            dataIndex: 'is_visible',
            key: 'is_b',
            width: 120,
            render: (text) => (
                text ? <Tag color="green">aktiv</Tag> : <Tag>archiviert</Tag>
            ),
            sorter: (a, b) => a.is_visible - b.is_visible,
        },
        {
            title: 'Teilnehmer',
            dataIndex: 'member_count',
            key: 'member_count',
            sorter: (a, b) => a.member_count - b.member_count,
        },
        {
            title: 'Einladungen',
            dataIndex: 'invitation_count',
            key: 'invitation_count',
            sorter: (a, b) => a.invitation_count - b.invitation_count,
        },
        {
            title: 'Rechnungen',
            dataIndex: 'invoice_count',
            key: 'invoice_count',
            sorter: (a, b) => a.invoice_count - b.invoice_count,
        },
    ];

    const normalizeFormData = (data) => {
        if (data['id']) data['set_statuses'] = data['statuses'];
        if (data['id']) data['set_desc_statuses'] = data['desc_statuses']
        return normalizeDateFields(data,
          ['registration_latest_date', 'date_from', 'date_to']);
    }

    const normalizeSendData = (data) => {
        return normalizeOutDateFields(data,
          ['registration_latest_date', 'date_from', 'date_to']);
    }

    return <CRUD
        keyName="meeting-control"
        title={showArchived ? 'Archivierte Tagungen' : 'Tagungen verwalten'}
        itemName="tagung"
        FormComponent={MeetingControlForm}
        tableColumns={columns}
        searchParams={showArchived ? {archive_only: true} : {}}
        apiList={api.meetings.meetingControlList}
        apiRetrieve={api.meetings.meetingControlRetrieve}
        apiCreate={api.meetings.meetingControlCreate}
        apiUpdate={api.meetings.meetingControlUpdate}
        apiDelete={api.meetings.meetingControlDelete}
        normalizeSendData={normalizeSendData}
        normalizeFormData={normalizeFormData}
        renderTopContent={() => (
            <div className="mb-20">
                <MeetingArchiveToggle showArchived={showArchived} onChange={setShowArchived}/>
            </div>
        )}
        childrenActions={{
            'place': {
                childrenActionName: 'Tagungsort zur Tagung',
                ChildrenCRUD: MeetingPlaceList,
            },
            'special_program': {
                childrenActionName: 'Fachprogramm zur Tagung',
                ChildrenCRUD: MeetingSpecialProgramList,
            },
            'accompany_program': {
                childrenActionName: 'Begleitprogramm zur Tagung',
                ChildrenCRUD: MeetingAccompanyProgramList,
            },
            'evening_program': {
                childrenActionName: 'Abendprogramm zur Tagung',
                ChildrenCRUD: MeetingEveningProgramList,
            },
            'parking_pass': {
                childrenActionName: 'Parkausweis zur Tagung',
                ChildrenCRUD: MeetingParkingPassList,
            },
            'email_template': {
                childrenActionName: 'Einladungsvorlage',
                ChildrenCRUD: MeetingEmailTemplateForm,
                width: 900,
            },
            'email_template2': {
                childrenActionName: 'Registrierungshinweis',
                ChildrenCRUD: MeetingEmailTemplate2Form,
                width: 900,
            },
        }}
    />
};

export default MeetingControlList;
